/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Aggregate health of the system information collection.
 */
export enum SystemInfoSummaryStatusType {
  SystemInfoSummaryStatusHealthy = 'Healthy',
  SystemInfoSummaryStatusDegraded = 'Degraded',
  SystemInfoSummaryStatusError = 'Error',
  SystemInfoSummaryStatusUnknown = 'Unknown',
}
